import { propertyMapUrl } from "~/api/manual/property-map";

export type ProxySource = { proxy: "property-map"; layer: string };

export type LayerSource = { url: string } | ProxySource;

export function resolveLayerSource(source: LayerSource): string {
  return "url" in source ? source.url : propertyMapUrl(source.layer, "wfs");
}
